const MIN = 0.25;
const MAX = 6;
const INTERVAL = 0.25;

export const SCORES = (() => {
  const result = [];

  for (let score = MIN; score <= MAX; score += INTERVAL) {
    result.push(score);
  }

  return result;
})();
